import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, commsHeader, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_VENDORS, GET_VENDORS_SUCCESS, GET_VENDORS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall.js';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getVendors({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/comms/configs`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...commsHeader,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_VENDORS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_VENDORS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VENDORS_ERROR, payload: error });
  }
}

export function* watchGetVendors() {
  yield takeEvery(GET_VENDORS, getVendors);
}

function* getVendorsSaga() {
  yield all([fork(watchGetVendors)]);
}

export default getVendorsSaga;
